import { render, staticRenderFns } from "./Rfi.vue?vue&type=template&id=5622b10a&scoped=true&lang=pug&"
import script from "./Rfi.vue?vue&type=script&lang=js&"
export * from "./Rfi.vue?vue&type=script&lang=js&"
import style0 from "./Rfi.vue?vue&type=style&index=0&id=5622b10a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5622b10a",
  null
  
)

export default component.exports